<template>
	<div class='knd-paragraaf knd-paragraaf-image'>
		<figure>
			<img :data-src="'https://pointer-dev.kro-ncrv.nl' + data.content.url" class="swiper-lazy">
			<div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>

<!--		<img :src="'https://pointer-dev.kro-ncrv.nl' + data.content.url" alt="">

 --> <!-- {{'https://pointer-dev.kro-ncrv.nl' + data.content.url}} -->
			<figcaption class='knd-caption'>{{data.content.description}}</figcaption>
		</figure>
	</div>
</template>

<script>

	const vueObject = {
		props: ['data'],
		methods: {}
	}

	export default vueObject;
</script>